/**
 * @param email {string}
 * @returns {Promise<{result: string, reason: string}>}
 */
module.exports = async function kickboxCheck(email) {
    const domain = 'https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1';
    const emailParam = encodeURIComponent(email);
    const url = `${domain}/kickbox-email-check?email=${emailParam}`;

    try {
        const res = await fetch(url);

        if (res.status !== 200) {
            return {
                result: 'kickbox-is-broken',
                reason: 'kickbox-is-broken',
            };
        }

        const json = await res.json();

        return {
            result: json.result,
            reason: json.reason,
        };
    } catch (e) {
        return {
            result: 'kickbox-is-broken',
            reason: 'kickbox-is-broken',
        };
    }
};
